/* eslint-disable */
import Api from '@/api/services/Api';

const route = '/curso'

export default {
    get: params => {
        let customRoute = `${route}?estudiante_id=${params.estudianteId}&expand=campus,seccion,tarifa,financiamiento_tipo,status_description`
        switch (params.cursoEstado) {
            case "2": customRoute = `${route}?estudiante_id=${params.estudianteId}&estado=1&expand=campus,seccion,tarifa,financiamiento_tipo,status_description`
                break;
            case "3": customRoute = `${route}?estudiante_id=${params.estudianteId}&estado=0&expand=campus,seccion,tarifa,financiamiento_tipo,status_description`
                break;
            case "6": customRoute = `${route}?estudiante_id=${params.estudianteId}&${params.customfilter}&expand=campus,seccion,tarifa,financiamiento_tipo,status_description`
                break;
            default: break;
        }
        return Api().get(customRoute, { params, crossDomain: true })
    },
    loadDetails: payload => Api().get(`${route}/${payload.id}?expand=campus,seccion,tarifa,financiamiento_tipo,grado,grupo,status_description`, { crossDomain: true }),
    getHistory: payload => Api().get(`${route}/${payload.id}?expand=campus,seccion,tarifa,financiamiento_tipo,status_description,history`, { crossDomain: true }),
    post: payload => Api().post(`${route}?expand=campus,seccion,tarifa,financiamiento_tipo,grado,grupo,status_description`, payload),
    put: payload => Api().put(`${route}/${payload.id}?expand=campus,seccion,tarifa,financiamiento_tipo,grado,grupo,status_description`, payload),
    delete: payload => Api().delete(`${route}/${payload.id}&expand=campus,seccion,tarifa,financiamiento_tipo,status_description`)
}
